import clsx from "clsx";
import { FC, PropsWithChildren, ReactElement } from "react";

import { onActivateKeyDown } from "@ryde/shared";

import { FramerTooltip } from "../../common";

export interface ICellSimple extends PropsWithChildren {
  color?: string;
  tooltipDisabled?: boolean;
  classNamesAdded?: string;
  tooltipContentOverride?: string;
  onClick?: () => void;
}

export const CellSimple: FC<ICellSimple> = ({
  children,
  color,
  tooltipDisabled,
  onClick,
  classNamesAdded = "",
  tooltipContentOverride,
}): ReactElement => {
  const textContent = children || "";
  const className = clsx("cell_simple", classNamesAdded);
  return (
    <>
      {tooltipDisabled ? (
        <div
          className={className}
          onClick={onClick}
          onKeyDown={onClick ? onActivateKeyDown(onClick) : undefined}
          role={onClick ? "button" : undefined}
          tabIndex={onClick ? 0 : undefined}
          style={{ color }}
        >
          {textContent}
        </div>
      ) : (
        <div
          className={className}
          onClick={onClick}
          onKeyDown={onClick ? onActivateKeyDown(onClick) : undefined}
          role={onClick ? "button" : undefined}
          tabIndex={onClick ? 0 : undefined}
        >
          <FramerTooltip
            content={tooltipContentOverride || textContent}
            rtlStrippedBottomLeftPlacement
          >
            <>
              {!!color && <span style={{ color }}>{textContent}</span>}
              {!color && <>{textContent}</>}
            </>
          </FramerTooltip>
        </div>
      )}
    </>
  );
};
